lmApp.service('SuperuserSrv', ['$http', function ($http) {
  var service = {};

  service.GetOperators = function () {
    var url = '/discovery:80' + '/sdp/v2/operators';
    var request = {};
    request.method = 'GET';
    request.url = url;
    request.headers = {};
    request.headers['X-Auth-Token'] = lh.common.config.get('authToken');

    return $http(request);
  };

  service.GetAccessToken = function (operator) {
    var url = '/discovery:80' + '/sdp/v2/access-tokens';
    var request = {};
    request.method = 'POST';
    request.url = url;
    request.data = {
      'usertype': 'operator',
      'userid': operator.id,
      'lifetime': 3600
    };
    request.headers = {};
    request.headers['X-Auth-Token'] = lh.common.config.get('authToken');

    return $http(request);
  };

  return service;
}]);